module.exports = __webpack_public_path__ + "static/media/hexiaodianAPPruanjian.1a94a85a.png";